"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SecureYourArrival() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="221510" id="secure-your-arrival" className="bg-background text-foreground py-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div ref={ref} className={`relative mx-auto max-w-6xl overflow-hidden rounded-md bg-secondary px-6 py-20 text-center shadow-2xl sm:px-12 sm:py-24 transition-all duration-1000 ease-out transform ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        {}
        <div className="absolute inset-0 opacity-[0.15] pointer-events-none mix-blend-overlay">
          <svg className="h-full w-full" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern id="geometric-pattern" width="60" height="60" patternUnits="userSpaceOnUse">
                <path d="M30 0L60 30L30 60L0 30Z" fill="none" stroke="currentColor" strokeWidth="1" className="text-foreground" />
                <path d="M0 0L60 60M60 0L0 60" fill="none" stroke="currentColor" strokeWidth="0.5" className="text-foreground" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#geometric-pattern)" />
          </svg>
        </div>

        <div className="relative z-10 mx-auto max-w-3xl">
          <h2 className="font-default text-4xl font-bold tracking-tight text-foreground sm:text-5xl lg:text-6xl uppercase">
            Request Your Pre-Flight Assessment
          </h2>
          <p className="mt-6 text-lg leading-8 text-foreground/90 font-default max-w-2xl mx-auto">
            No Paperwork. No Commitment. Pilot-to-Pilot. Secure your lifetime in-home care plan and maintain your connection to the cockpit.
          </p>
          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg h-14 px-8 text-base rounded-md" asChild>
              <Link to="/FlightDeckPage">
                <SafeHydrate><Calendar className="mr-2 size-5" /></SafeHydrate>
                Schedule a Free Consultation
              </Link>
            </Button>
            <Button size="lg" variant="outline" className="w-full sm:w-auto border-2 border-foreground text-foreground hover:bg-foreground hover:text-secondary shadow-lg bg-transparent h-14 px-8 text-base rounded-md" asChild>
              <Link to="tel:8883702846">
                <Phone className="mr-2 size-5" />
                888-370-2846
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}